import React from 'react';
import { toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import {
  Form, Input, Radio, Row, Col,
  Tooltip, Icon, Alert,
} from 'antd';
import CustomerButton from './CustomerButtonNew';
import DocConstant from './validate';
import './style/app.less';
import util from '../../../util/index';
import Instrution from './Instruction';

const RadioGroup = Radio.Group;
const FormItem = Form.Item;
const { TextArea } = Input;
const {
  checkNull,
  checkLicenseNull,
  checkLen,
} = DocConstant;
const {
  isCus,
} = util;
const store = ['modeListStore', 'initStore', 'homeStore'];
@inject(...store)
@observer
class ApplyApp extends React.Component {

  static defaultProps = {
    prefixCls: "app-apply-modal",
  }

  hasBetaStyle = (vers = []) => {
    const hasbeta = vers.some(function (el) {
      return /Beta/.test(el.version);
    })
    return {
      display: (hasbeta ? 'block' : 'none')
    }
  }
  getHelpTip = (title, otherStyle = {}) => {
    const { prefixCls } = this.props;
    return (<div className={`${prefixCls}-help-tip`} style={otherStyle}>
      <Tooltip placement="left" title={title}>
        <Icon type="question-circle-o" />
      </Tooltip>
    </div>);
  }
  render() {
    const { prefixCls, form,
      modeListStore: {
        getLicense, isApply, appDetail, appDetail: { ver }, buyAppResult,
      },
    } = this.props;
    const data = toJS(appDetail).app || {};
    const { s_number, s_name, s_version, s_beta, s_fb } = data;
    const isFb = !(s_fb === '0' || s_fb === '');
    const buyAppRes = toJS(buyAppResult);
    const layoutProps = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
      },
    };
    const { getFieldProps, getFieldValue } = form;
    const today = new Date();
    const nextDate = new Date(today);
    nextDate.setDate(today.getDate() + 7);
    const dateTime = `${nextDate.getFullYear()}-${nextDate.getMonth() + 1}-${nextDate.getDate()}`;
    const sEc = data.s_ec ? data.s_ec.split(',') : [];
    let cusName = '';
    if (!!localStorage.me) {
      const me = !!localStorage.me ? JSON.parse(localStorage.me) : { role: "" };
      if (me.member) cusName = me.member.m_Comname;
    }
    return (
      <Form>
        <FormItem label="应用编码 ：" {...layoutProps} >
          <Input disabled {...getFieldProps('s_number', { initialValue: s_number })} />
        </FormItem>
        <FormItem label="应用名称 ：" {...layoutProps} >
          <Input disabled {...getFieldProps('s_name', { initialValue: s_name })} />
        </FormItem>
        <FormItem {...layoutProps} label="版本类型 ：" style={this.hasBetaStyle(ver)}>
          <RadioGroup {...getFieldProps("s_beta", {
            initialValue: s_beta
          })}>
            <Radio value="0">稳定版</Radio>
            <Radio value="1">开发版</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="应用版本 ：" {...layoutProps} >
          <Input disabled {...getFieldProps('s_version', { initialValue: s_version })} />
        </FormItem>
        {
          !isFb && (
            <FormItem label="EC兼容 ：" {...layoutProps} required className={`${prefixCls}-required`}>
              <RadioGroup   {...getFieldProps("s_ec", {
								rules: [{ validator: checkLen }]
              })}>
                {
                  sEc.map(sec => (<Radio value={sec} key={sec}>{sec}</Radio>))
                }
              </RadioGroup>
            </FormItem>
          )
        }
        <FormItem label="客户 ：" {...layoutProps} required className={`${!isCus() && `${prefixCls}-required`}`}>
          <CustomerButton
            {...getFieldProps('c_id', {
              initialValue: isCus() ? cusName : '',
              rules: [{
                validator: isCus() ? null : checkNull
              }]
            })}
            disabled={isCus()}
            onChange={(id, record) => {
              if (id) {
                getLicense({
                  sw_id: data.sw_id, ecname: record.name || record.label, ecid: id, c_id: id,
                }).then((datas) => {
                  form.setFieldsValue({
                    c_id: id,
                    c_name: record.name || record.label,
                    license: datas,
                  });
                });
              } else {
                form.setFieldsValue({
                  c_id: '',
                  c_name: '',
                  license: '',
                })
              }
            }}
          />
        </FormItem>
        <FormItem label="授权用户 ：" {...layoutProps} required className={`${!isCus() && `${prefixCls}-required`}`}>
          <Input disabled={isFb || isCus()} {...getFieldProps('c_name', {
            initialValue: isCus() ? cusName : '',
            rules: [{
              validator: isCus() ? null : checkNull
            }]
          })} />
          {this.getHelpTip(isFb ? "选择客户自动生成授权用户" : "请填写EC授权信息中的授权用户")}
        </FormItem>
        {
          isFb && (
            <FormItem label="ecology版本 ：" {...layoutProps} required className={`${prefixCls}-required`}>
              <Input {...getFieldProps('bb', {
                rules: [{
                  validator: checkNull,
                }]
              })} />
              {this.getHelpTip("格式如：8.100.0531+KB8100170204（若无KB补丁包格式如：8.100.0531）")}
            </FormItem>
          )
        }
        {
          isFb && (
            <FormItem label="项目属性 ：" {...layoutProps}>
              <RadioGroup   {...getFieldProps("projectType", {
                initialValue: '0'
              })}>
                <Radio value='0'>售前项目</Radio>
                <Radio value='1'>售后项目</Radio>
                <Radio value='3'>本地demo</Radio>
              </RadioGroup>
            </FormItem>
          )
        }
        {
          !isFb && (
            <FormItem label="授权时间 ：" {...layoutProps}>
              <RadioGroup {...getFieldProps('type', {
                initialValue: "1"
              })} disabled={!getFieldValue('c_id') || getFieldValue('c_id') === ''}>
                <Radio value="0">临时（7天）</Radio>
                <Radio value="1">永久</Radio>
              </RadioGroup>
              {this.getHelpTip(getFieldValue('type') === '0' ? dateTime + "到期。选择客户以后即可选择永久" : "永久")}
            </FormItem>
          )
        }
        {
          !isFb && (
            <FormItem label="标识码 ：" {...layoutProps} required className={`${prefixCls}-required`}>
              <TextArea {...getFieldProps('license', {
                rules: [{
                  validator: checkLicenseNull
                }]
              })} rows={5} />
              {this.getHelpTip("license，如果是存在多个license的集群环境，请用逗号隔开如license1,license2...", { top: '-70px' })}
            </FormItem>
          )
        }
        {/* {
          !isFb && (
            <FormItem label="ecology版本 ：" {...layoutProps}>
              <RadioGroup {...getFieldProps('s_bb', {
                initialValue: 'Ecology8',
              })}>
                <Radio value="Ecology8">Ecology8</Radio>
                <Radio value="Ecology9">Ecology9</Radio>
              </RadioGroup>
            </FormItem>
          )
        } */}
        <Row>
          <Col sm={layoutProps.labelCol.sm} xs={layoutProps.labelCol.xs} />
          <Col sm={layoutProps.wrapperCol.sm} xs={layoutProps.wrapperCol.xs}>
            {
              getFieldValue('type') === '1' && (getFieldValue('c_id') && getFieldValue('c_id') !== '') && (<div className={`${prefixCls}-tip`}>
                <span style={{ color: '#ff9955' }}>
                  {
                    getFieldValue('c_id') === '588141' ?
                      '此申请会由云商店人员审批，请稍作等待，如长时间未通过可联系云商店人员' :
                      '此申请会由相关人员（项目、客服、客户经理）审批，请稍作等待，如长时间未通过可联系相关人员'
                  }
                </span>
              </div>)
            }
            {
              isApply && (<div className={`${prefixCls}-tip`}>
                <span style={{ color: '#ff9955' }}>您已申请过该应用无需申请</span>
              </div>)
            }
            <div className={`${prefixCls}-tip`}>
              <Instrution />
            </div>
          </Col>
        </Row>
        <div className={`${prefixCls}-alert`}>
          {
            buyAppRes && buyAppRes.tms ? buyAppRes.status === 'true' ?
              buyAppRes.tms.tms_isbuytype === '0' ? (
                <Alert message="提示" type="success" showIcon
                  description={`客户【${buyAppRes.tms.c_name}】应用试用授权申请成功，${dateTime}到期，请到【后台】->【我的应用】->【我的订单】-【应用订单】中获取文件`} />
              ) : (
                  <Alert message="提示" type="success" showIcon
                    description={`客户【${buyAppRes.tms.c_name}】应用永久授权申请成功，审批完系统会通知您，请到【后台】->【我的应用】->【我的订单】-【应用订单】中获取文件`} />
                ) : (
                <Alert message="提示" type="error" showIcon description="授权申请失败，请联系云商店管理员！" />
              ) : null
          }
        </div>
      </Form>
    )
  }
}

export default ApplyApp;


// WEBPACK FOOTER //
// ./src/components/util/appApply/AppApply.js